import React from 'react';
import './Hero.css';

import HeroComponent from '../../components/Hero/Hero.js';


function Hero() {
  return (
      <div className='hero-container'>
            <HeroComponent/>
      </div>
  );
};

export default Hero;
